import Tween from "tween.ts";
import Animation from "./Animation";


export default class ModalPopAnimation extends Animation {
  constructor(startVal: number, targetVal: number, duration: number, onUpdate:(v: number) => void, onComp: () => void) {
    super();
    const pop = { v: startVal }
    new Tween.Tween(pop)
      .to({ v: targetVal }, duration)
      .easing(Tween.Easing.Cubic.Out)
      .onUpdate((pop: { v: number }) => onUpdate(pop.v))
      .onComplete(() => onComp())
      .start();
  }
}